(function () {
  'use strict';

  /* @ngdoc object
   * @name main.dades
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.dades', [
      'ui.router'
    ]);
}());
